import { useAuth } from 'contexts/AuthContext';
import React, { FC, useState } from 'react';
import { useLoginMutation, useReactivateUserMutation, useRegisterUserMutation, useVerifyCodeMutation } from 'store/api';

export interface PinputCodeProps {form:{email:string,name:string,password:string,repeatPassword:string};} 

const PinputCode:FC<PinputCodeProps> = ({form}) => {
  const [code, setCode] = useState<string[]>(['', '', '', '']);
  const [error, setError] = useState('');
  const [alert, setAlert] = useState<string | null>(null);

  const [verifyCode] = useVerifyCodeMutation();
  const [register] = useRegisterUserMutation();
  const [login] = useLoginMutation();
  const [reactivateUser] = useReactivateUserMutation();
  const {login:loginAuth}= useAuth();

  const handleChange = async(value: string, index: number) => {
    if (/^\d?$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
  
      if (index === 3 && value) {
        const {data,error:err}= await verifyCode({ email: form.email ,code: newCode.join('') });
        if(err)setError('Código incorrecto');
        if(data){
            if(data.meta.status===200){
              setError('');
              const {data:registerData, error:registerError} = await register(form);
              if(registerData){
                if(registerData.meta.status===200){
                  const {error:loginError, data:loginData} = await login({email:form.email,password:form.password});
                  if (loginError) {
                    if ('status' in loginError) {
                      const fetchError = loginError as { status: number; data: { message: string; statusMessage: string } };

                      switch (fetchError.status) {
                        case 401:
                          setError('Usuario o contraseña incorrectos');
                          break;
                        case 404:
                          setError('Usuario no encontrado');
                          break;
                        case 500:
                          setError('Error en el servidor. Intenta más tarde.');
                          break;
                        default:
                          setError('Algo salió mal. Intenta nuevamente.');
                      }
                      setTimeout(() => setError(''), 2000);
                    }

                  } else{
                    const { customer, token } = loginData;
                    const { password, fcm, ...userWithoutSensitiveData } = customer;
                    setAlert('Usuario registrado exitosamente');
                    setTimeout(() => {
                      setAlert(null);
                      return loginAuth({ ...userWithoutSensitiveData, token });      
                    }, 1500);
                  }

              }else if(registerData.meta.status===409||registerData.meta.status===410) setError('El usuario ya existe');
               else setError('Error al registrar usuario');
            }
            if(registerError){
              if('status' in registerError){
                const fetchError = registerError as { status: number; data: { message: string; statusMessage: string } };
                
                switch (fetchError.status) {
                  case 409:
                    const {data:userReactivate,error:err}= await reactivateUser({name:form.name,email:form.email, password:form.password});
                    if(err) setError('Error al registrar usuario');
                    
                    if(userReactivate){
                      if(userReactivate.meta.status===201){
                        const {error:loginError, data:loginData} = await login({email:form.email,password:form.password});
                        if (loginError) {
                          if ('status' in loginError) {
                            const fetchError = loginError as { status: number; data: { message: string; statusMessage: string } };
                            switch (fetchError.status) {
                              case 401:
                                setError('Usuario o contraseña incorrectos');
                                break;
                              case 404:
                                setError('Usuario no encontrado');
                                break;
                              case 500:
                                setError('Error en el servidor. Intenta más tarde.');
                                break;
                              default:
                                setError('Algo salió mal. Intenta nuevamente.');
                            }
                            setTimeout(() => setError(''), 2000);
                          }
                        } else{

                          const { customer, token } = loginData;
                          const { password, fcm, ...userWithoutSensitiveData } = customer;
                          setAlert('Usuario registrado exitosamente');
                          setTimeout(() => {
                            setAlert(null);
                            return loginAuth({ ...userWithoutSensitiveData, token });      
                          }, 1500);
                        }
                      }
                    }

                    
                    break;
                  case 410:
                    setError('El usuario ya existe');
                    break;
                  default:
                    setError('Error al registrar usuario');
                }
              }
            }
          }
        }
        return;
      }
      if (value && index < 3) {
        const nextInput = document.getElementById(`digit-${index + 1}`);
        nextInput?.focus();
      }
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (event.key === 'Backspace' && !code[index] && index > 0) {
      const prevInput = document.getElementById(`digit-${index - 1}`);
      prevInput?.focus();
    }
  };

  return (
    <div  className="flex flex-col items-center gap-4">
      <div className="flex gap-2">
        {code.map((digit, index) => (
          <input
            key={index}
            id={`digit-${index}`}
            type="text"
            value={digit}
            maxLength={1}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className="w-12 h-12 text-center text-xl border border-gray-300 rounded-xl"
          />
        ))}
      </div>
       {error && <p className="text-red-600 text-sm">{error}</p>}
       {alert && (
        <div
          className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-6 py-3 rounded-2xl shadow-2xl transition-all duration-300 ease-in-out z-50"
          style={{ opacity: 1 }}
        >
          {alert}
        </div>
      )}
     </div>
  );
};

export default PinputCode;
